<footer class="container-fluid">
  <div class="footer-row-utility row">
    <div class="col-sm-3 d-flex align-items-center">
      <div class="footer-logo-wrapper">
        <a class="footer-logo" target="_blank" href="http://www.wcb.ny.gov/">
          <span class="visually-hidden">ONBOARD Logo - Navigate to Home</span>
        </a>
      </div>
    </div>
    <div class="col-sm-9 d-flex align-items-center">
      <div class="footer-nav-utility">
        <ul class="list-style-none d-flex align-items-center">
          <li>
            <a href="http://www.wcb.ny.gov/privacy-policies.jsp" target="_blank">Privacy Policy</a>
          </li>
          <li>
            <a href="http://www.wcb.ny.gov/content/accessibility.jsp" target="_blank">
              Accessibility
            </a>
          </li>
          <li>
            <a
              href="http://www.wcb.ny.gov/content/ebiz/information/contact_wcb.jsp"
              target="_blank"
            >
              Technical Support
            </a>
          </li>
          <li>
            <a href="http://www.wcb.ny.gov/content/main/Contact.jsp" target="_blank">Contact WCB</a>
          </li>
          <li>
            <a href="https://public.govdelivery.com/accounts/NYWCB/subscriber/new" target="_blank">
              Get WCB Notifications
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</footer>
